import React from "react";
import { Switch, Route } from "react-router-dom";
import Courses from "../course";
import SingleCourse from "../course/SingleCourse";

const CourseRoutes = () => {
  return (
    <Switch>
      <Route path="/courses/:_id" component={SingleCourse} />
      <Route exact path="/courses" component={Courses} />
    </Switch>
  );
};

export default CourseRoutes;
